import * as React from 'react'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

const getInitialState = () => ({
	priceByNight: localStorage.getItem('priceByNight') === 'true'
})

export function CompetitionAnalyzerPriceByNightTablesProvider({children}) {
	const {state, replaceState} = useAppContextState(getInitialState())

	return <Context.Provider value={{state, replaceState}}>
		{children}
	</Context.Provider>
}

export default Context